// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__5dTrH","pagination":"style_pagination__tFUi9"};